import { render, staticRenderFns } from "./ProjectEditTabAccount.vue?vue&type=template&id=bd4cd6a4&"
import script from "./ProjectEditTabAccount.vue?vue&type=script&lang=js&"
export * from "./ProjectEditTabAccount.vue?vue&type=script&lang=js&"
import style0 from "./ProjectEditTabAccount.vue?vue&type=style&index=0&id=bd4cd6a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports